<template>
    <div class="container">
        <b-modal 
            :model-value="modEditCentroCostos" 
            @update:model-value="updateModalValue"
            :no-close-on-backdrop="true" 
            hide-header 
            hide-footer 
            centered
            size="md"
        >
            <div class="text-center mb-3">
                <h5>{{ labels.title }}</h5> 
            </div>
            
            <div class="">
                <b-row class="mb-3 align-items-center">
                    <b-col cols="4" class="text-left">
                        <label class="font-weight-bold">{{ labels.centroCosto }}</label> 
                    </b-col>
                    <b-col cols="8">
                        <div v-for="cc in centroCostoFiltrado" :key="cc.id" class="text-left"> 
                            <span class="badge badge-info p-2">
                                {{ cc?.descripcion }} ({{ cc?.centro_costo }})
                            </span>
                        </div>
                    </b-col>
                </b-row>
                
                <b-row class="mb-3 align-items-center">
                    <b-col cols="4" class="text-left">
                        <label class="font-weight-bold">{{ labels.porcentaje }}</label> 
                    </b-col>
                    <b-col cols="8">
                        <input 
                            type="number" 
                            v-model.number="porcentajeLocal"
                            class="form-control"
                            min="0"
                            max="100"
                            step="0.01"
                            placeholder="0.00"
                            required
                        >
                        <small class="text-muted">* {{ labels.porcentajeHelp }}</small>
                    </b-col>
                </b-row>
                
                <b-row class="mt-3">
                    <b-col cols="12" class="d-flex justify-content-end gap-2">
                        <b-button 
                            variant="danger" 
                            @click="eliminaRegistro"
                            class="mr-auto"
                        >
                            {{ labels.deletePorcentajecc }}
                        </b-button>
                        <b-button 
                            variant="primary" 
                            @click="aceptaCentroCostos"
                            :disabled="isLoading || porcentajeLocal === Infocc?.porcentaje"
                        >
                            {{ labels.save }}
                        </b-button>
                        <b-button 
                            variant="secondary" 
                            @click="cierraModal"
                        >
                            {{ labels.close }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
        
        <InacticaItem 
            :InactivaItem="showDelPorcecc" 
            @confirmDelete="deletePorcentajecc" 
            @cierraModal="cierraModalDelet"
        />
    </div>
</template>

<script>
import CentroCostos from '../../services/CentroCostos'
import ContratoCentroCostos from '../../services/ContratoCentroCostos'
import InacticaItem from '../utils/InacticaItem.vue'

export default {
    name: 'EditarCentroCosto',
    components: { 
        InacticaItem 
    },
    props: {
        modEditCentroCostos: {
            type: Boolean,
            required: true,
            default: false
        },
        numContrato: {
            type: [String, Number],
            required: true
        },
        Infocc: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },
    data() {
        return {
            listCentroCostos: [],
            showDelPorcecc: false,
            id_ccContrato: '',
            porcentajeLocal: 0,
            isLoading: false,
            datosOriginales: {}
        }
    },
    computed: {
        labels() {
            const isSpanish = this.$store.state._language === "es-ES"
            return {
                title: isSpanish ? 'Editar centro de costo' : 'Edit cost center',
                save: isSpanish ? 'Guardar' : 'Save',
                close: isSpanish ? 'Cerrar' : 'Close',
                deletePorcentajecc: isSpanish ? 'Eliminar' : 'Delete',
                centroCosto: isSpanish ? 'Centro Costo' : 'Cost Center',
                porcentaje: isSpanish ? 'Porcentaje' : 'Percentage',
                porcentajeHelp: isSpanish ? 'Valor entre 0 y 100' : 'Value between 0 and 100',
                confirmDelete: isSpanish ? '¿Está seguro de eliminar este porcentaje?' : 'Are you sure you want to delete this percentage?'
            }
        },
        centroCostoFiltrado() {
            if (!this.Infocc || !this.listCentroCostos) return []
            return this.listCentroCostos.filter(
                (cc) => cc.centro_costo === this.Infocc.centro_costo
            )
        },
        hayCambios() {
            return this.porcentajeLocal !== this.datosOriginales.porcentaje
        }
    },
    methods: {
        updateModalValue(value) {
            this.$emit('update:modEditCentroCostos', value)
            if (!value) {
                this.resetearValores()
            }
        },
        
        cierraModal() {
            this.$emit('update:modEditCentroCostos', false)
            this.$emit('cierraModal', false)
            this.resetearValores()
        },
        
        resetearValores() {
            this.porcentajeLocal = this.Infocc?.porcentaje || 0
            this.datosOriginales = { ...this.Infocc }
            this.showDelPorcecc = false
            this.id_ccContrato = ''
        },
        
        async aceptaCentroCostos() {
            // Validaciones
            if (this.porcentajeLocal < 0 || this.porcentajeLocal > 100) {
                this.$toast.warning(this.$store.state._language === "es-ES" 
                    ? 'El porcentaje debe estar entre 0 y 100' 
                    : 'The percentage must be between 0 and 100'
                )
                return
            }
            
            if (this.porcentajeLocal === this.Infocc.porcentaje) {
                this.$toast.info(this.$store.state._language === "es-ES" 
                    ? 'No hay cambios para guardar' 
                    : 'No changes to save'
                )
                return
            }
            
            if (this.isLoading) return
            
            this.isLoading = true
            
            try {
                const info = {
                    'numContrato': this.Infocc.nro_contrato || this.numContrato,
                    'vigencia': this.Infocc.vigencia,
                    'centroCosto': this.Infocc.centro_costo,
                    'porcentaje': this.porcentajeLocal,
                    'id': this.Infocc.id,
                    'idUser': this.$store.state.userId
                }

                const res = await ContratoCentroCostos.updateContratoCentroCosto(info)
                
                if (res.status === 200) {
                    this.$toast.success(res.data.message)
                    this.$emit('reloadTblCntCst', this.Infocc.vigencia)
                    this.cierraModal()
                }
            } catch (error) {
                console.error('Error al actualizar:', error)
                if (error.response && error.response.data) {
                    this.$toast.error(error.response.data.message)
                } else {
                    this.$toast.error(this.$store.state._language === "es-ES" 
                        ? 'Error al actualizar el centro de costo' 
                        : 'Error updating cost center'
                    )
                }
            } finally {
                this.isLoading = false
            }
        },
        
        eliminaRegistro() {
            this.showDelPorcecc = true
            this.id_ccContrato = this.Infocc.id
        },
        
        cierraModalDelet() {
            this.showDelPorcecc = false
        },
        
        async deletePorcentajecc() {
            if (!this.id_ccContrato) {
                this.$toast.error(this.$store.state._language === "es-ES" 
                    ? 'No se puede eliminar: ID no encontrado' 
                    : 'Cannot delete: ID not found'
                )
                return
            }
            
            if (this.isLoading) return
            
            this.isLoading = true
            
            try {
                const res = await ContratoCentroCostos.deletPorcentajeCentroCosto(this.id_ccContrato)
                
                if (res.status === 200) {
                    this.$toast.success(res.data.message)
                    this.showDelPorcecc = false
                    this.$emit('reloadTblCntCst', this.Infocc.vigencia)
                    this.cierraModal()
                    
                    // Navegación suave en lugar de location.reload()
                    this.$emit('centroCostoEliminado')
                }
            } catch (error) {
                console.error('Error al eliminar:', error)
                this.$toast.error(error.response?.data?.message || 
                    (this.$store.state._language === "es-ES" 
                        ? 'Error al eliminar el centro de costo' 
                        : 'Error deleting cost center'
                    )
                )
            } finally {
                this.isLoading = false
            }
        },
        
        async cargarCentrosCosto() {
            try {
                const res = await CentroCostos.getAllCentroCostos()
                this.listCentroCostos = res.data.listCentroCostos || []
            } catch (err) {
                console.error('Error cargando centros de costo:', err)
                this.$toast.error(this.$store.state._language === "es-ES" 
                    ? 'Error al cargar los centros de costo' 
                    : 'Error loading cost centers'
                )
            }
        }
    },
    watch: {
        modEditCentroCostos(newValue) {
            if (newValue && this.Infocc) {
                this.resetearValores()
            }
        },
        // Observar cambios en Infocc para actualizar valores
        Infocc: {
            handler(newVal) {
                if (newVal && this.modEditCentroCostos) {
                    this.resetearValores()
                }
            },
            deep: true
        }
    },
    mounted() {
        this.cargarCentrosCosto()
        if (this.Infocc) {
            this.resetearValores()
        }
    }
}
</script>

<style scoped>
.gap-2 {
    gap: 0.5rem;
}

.badge-info {
    background-color: #17a2b8;
    color: white;
    font-size: 0.9rem;
}

input[type="number"].form-control {
    font-size: 1rem;
    padding: 0.375rem 0.75rem;
}

input[type="number"].form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Eliminar spinners en inputs number */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.mr-auto {
    margin-right: auto !important;
}
</style>
